import type { StrainImage } from '@shared';
import { createDisplayObjectUrl } from './objectUrls';
import type { LocalProductImageRecord } from './types';

/** Map a durable local image record to the StrainImage display shape. */
export function localRecordToStrainImage(
  record: LocalProductImageRecord,
): StrainImage {
  const url = createDisplayObjectUrl(record.blob);
  return {
    id: record.id,
    strainId: record.productId,
    filename: record.id,
    originalFilename: record.originalFilename,
    mimeType: record.mimeType,
    sizeBytes: record.blob.size,
    width: record.width,
    height: record.height,
    thumbnailFilename: null,
    imageCategory: record.imageCategory,
    ocrText: null,
    cropMetadata: null,
    sortOrder: record.sortOrder,
    ocrStatus: 'none',
    isPrimary: record.isPrimary,
    createdAt: record.createdAt,
    url,
    thumbnailUrl: url,
    source: 'local',
  };
}

export function sortLocalImageRecords(
  records: LocalProductImageRecord[],
): LocalProductImageRecord[] {
  return [...records].sort((a, b) => {
    if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
    return a.createdAt.localeCompare(b.createdAt);
  });
}
